enum DefaultExceptionTypes {
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  REQUIRE_SUBSCRIPTION = "REQUIRE_SUBSCRIPTION",
  NOT_FOUND = "NOT_FOUND",
  BAD_REQUEST = "BAD_REQUEST",
  CONFLICT = "CONFLICT",
  ABORT_REQUEST = "ABORT_REQUEST",
  EXTERNAL_RESOURCE_UNAVAILABLE = "EXTERNAL_RESOURCE_UNAVAILABLE",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  UNEXPECTED_ERROR = "UNEXPECTED_ERROR",
  NETWORK_ERROR = "NETWORK_ERROR",
}

export default DefaultExceptionTypes;
